var supportedPluginViewElements = Object.freeze({
   PROGRESS_BAR: 'progressBar',
   MEDIA: 'media',
   BEFORE_AFTER_PLAY_CONTROLS: 'beforeAfterPlayControls',
   PLAYER: 'player'
});

export default supportedPluginViewElements;
